import { InputAddressData } from '@afterpaytouch/core'
import { AmexNumberFormat, CardDefaultValue, StandardNumberFormat } from '@afterpaytouch/form'
import { NewCard } from '../../model'

export interface FormCardDetails {
  cardHolderName: string
  cardNumber: string
  expiryDate: string
  cvv: string
}
export type BillingAddress = NewCard['address']

export interface NewPaymentMethodFormSchema {
  cardRadio?: boolean
  cardField: CardDefaultValue
  billingAndProfileAddressEqual?: boolean
  creditCardMessage?: boolean
  address: InputAddressData
  addressPreview?: boolean
  errors?: boolean
  submitButton?: boolean
}

export interface FormComponents {
  addressPreview: () => JSX.Element
  errors: () => JSX.Element
  creditCardMessage: () => JSX.Element
  submitButton: () => JSX.Element
}
export interface CardFormat {
  NUMBER_FORMAT: AmexNumberFormat.NUMBER_FORMAT | StandardNumberFormat.NUMBER_FORMAT
  CVV_FORMAT: AmexNumberFormat.CVV_FORMAT | StandardNumberFormat.CVV_FORMAT
}
export interface SchemaUpdates {
  billingCheckboxTicked: boolean
  isTopazError: boolean
  displayErrors: boolean
  showCardFieldHeading: boolean
  showCreditCardMessage: boolean
  showCardHolderNameField: boolean
}

export type SupportedNewPaymentType = 'card' | 'applePay'

export enum TopazErrorContext {
  saveNewCardPaymentMethodSUP = 'saveNewCardPaymentMethodSUP',
  saveNewCardPaymentMethod = 'saveNewCardPaymentMethod',
  recoverableFlow = 'recoverableFlow',
  retrieveNewCard = 'retrieveNewCard',
}
